export function applyVariablesTransformer(replaceVariableRegExp = /%{(.*?)}/g) {
    return (labelProps, value) => {
        if (!labelProps.variables) {
            return value;
        }
        const match = value.match(replaceVariableRegExp);
        if (!match) {
            return value;
        }
        const { variables } = labelProps;
        const matches = [...match];
        return matches.reduce((updatedValue, placeholder) => {
            var _a;
            const dataKey = placeholder.slice(2, placeholder.length - 1);
            return updatedValue.replace(placeholder, (_a = variables[dataKey]) !== null && _a !== void 0 ? _a : placeholder);
        }, value);
    };
}
//# sourceMappingURL=variablesTransformer.js.map